

















































































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';
import BookmarkIcon from '@/components/icons/Bookmark.vue';
import StatusTag from '@/componentsV2/atoms/StatusTag/StatusTag.vue';
import OfferTypeTag from '@/components/molecules/OfferTypeTag/OfferTypeTag.vue';

import { SpecialOfferTags } from '@/views/Offers/OfferDetail/OfferDetail.vue';

import {
  getRenewedLabel,
  EOfferRulesName,
  SpecialOfferTypeEnum
} from '@/models/offer';
import DateUtils from '@/utils/DateUtils';
import EmptyImageIcon from '@/components/icons/EmptyImage.vue';

@Component({
  components: {
    Typography,
    GhostButton,
    ArrowRightInfoIcon,
    BookmarkIcon,
    StatusTag,
    EmptyImageIcon,
    OfferTypeTag
  }
})
export default class OfferItem extends Vue {
  @Prop() item!: any;

  get renewedByRules() {
    return getRenewedLabel(
      this.item.rules.filter(
        (rule: any) => rule.name === EOfferRulesName.RENEWED_RULE
      )[0]
    );
  }

  get isBirthdayOffers() {
    return this.item.type === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get date() {
    return `Created on ${DateUtils.formattedDate({
      date: this.item.createdAt,
      applyTimezone: true
    })}`;
  }

  get inactiveOffer() {
    return !this.item.image;
  }

  goToOfferDetail() {
    this.$router.push(`/special-coins-offers/${this.item.id}`);
  }
}
